/**
 * How `evictions.containing_subdivision` got its value: an automatic point-in-polygon match
 * against the property coordinates, or a person's manual selection/override. See EE-364 R2.2.
 */
export enum SubdivisionSource {
  GEOLOCATION = 'GEOLOCATION',
  MANUAL = 'MANUAL'
}
